export default "__VITE_ASSET__SIsqkaPY__"